
export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.treatments': 'Trattamenti',
  'nav.howItWorks': 'Come funziona',
  'nav.supervision': 'Supervisione',
  'nav.about': 'Chi siamo',
  'nav.bookNow': 'Prenota ora',
  'nav.language': 'Lingua',

  // Hero
  'hero.badge': 'Medici veri. Cure vere. Tranquillità vera.',
  'hero.title.line1': 'Meriti un sorriso',
  'hero.title.line2': 'Di cui essere orgoglioso',
  'hero.subtitle1': 'Che si tratti di un dolore che hai ignorato, un sorriso che hai nascosto, o costi che ti hanno fatto aspettare — non devi più aspettare.',
  'hero.subtitle2': 'Rendiamo le cure dentali di livello mondiale in Turchia sicure, supportate e completamente alla tua portata — con un medico che supervisiona ogni passo.',
  'hero.cta.primary': 'Inizia il mio percorso',
  'hero.cta.secondary': 'Parla prima con qualcuno',
  'hero.feature1': 'Supervisionato da un medico dall\'inizio alla fine',
  'hero.feature2': 'Cure adatte alla tua vita e al tuo budget',
  'hero.feature3': 'Supportato ad ogni passo, vicino o lontano',

  // Services
  'services.badge': 'Il tuo percorso inizia qui',
  'services.title': 'Trattamenti che cambiano come ti senti ogni giorno',
  'services.subtitle': 'Che tu sia pronto a sorridere senza esitazione, mangiare senza preoccupazioni, o semplicemente sentirti di nuovo te stesso — siamo qui per aiutarti',
  'services.cta': 'Esplora tutti i trattamenti',
  'services.swipeHint': 'Scorri per esplorare altri trattamenti',
  'services.learnMore': 'Scopri di più',
  'services.startingFrom': 'A partire da',
  'services.perTooth': 'per dente',

  'service.implants.title': 'Impianti dentali',
  'service.implants.desc': 'Mangia, ridi e parla con piena fiducia. Sentiti te stesso con denti che sembrano, si sentono e funzionano come quelli naturali.',
  'service.veneers.title': 'Faccette in porcellana',
  'service.veneers.desc': 'Smetti di nascondere il tuo sorriso nelle foto. Svegliati ogni giorno amando ciò che vedi nello specchio con un sorriso che finalmente ti appartiene.',

  'service.smile.title': 'Smile Makeover',
  'service.smile.desc': 'Trasforma come ti senti riguardo a te stesso. Un restyling completo del sorriso progettato intorno al tuo viso, alla tua vita e alla fiducia che meriti.',

  'service.orthodontics.title': 'Ortodonzia',
  'service.orthodontics.desc': 'Raddrizza i denti senza imbarazzo. Trattamento discreto che si adatta al tuo stile di vita e ti dà il sorriso che hai sempre voluto.',

  'service.whitening.title': 'Sbiancamento dentale',
  'service.whitening.desc': 'Sentiti sicuro in ogni conversazione. Un sorriso più luminoso e bianco che ti fa sentire bene ogni volta che parli.',

  'service.root.title': 'Devitalizzazione',
  'service.root.desc': 'Smetti di vivere con il dolore ai denti. Salva il tuo dente naturale e torna a goderti la vita senza disagio o preoccupazione costante.',

  'service.crowns.title': 'Corone dentali',
  'service.crowns.desc': 'Proteggi e ripristina i denti danneggiati per poter mangiare di nuovo ciò che ami. Corone resistenti e dall\'aspetto naturale che durano anni.',

  'service.allon4.title': 'Impianti All-on-4',
  'service.allon4.desc': 'Riprendi la tua vita in un solo giorno. Un set completo di denti permanenti che ti permettono di mangiare, sorridere e vivere senza limiti.',

  // How It Works
  'how.badge': 'Processo semplice',
  'how.title': 'Come funziona',
  'how.subtitle': 'Quattro semplici passi per ottenere cure dentali di livello mondiale con totale trasparenza',
  'how.cta': 'Inizia il tuo percorso',

  'how.step1.number': '01',
  'how.step1.title': 'Prenota il tuo trattamento',
  'how.step1.desc': 'Scegli il tuo trattamento dentale e carica le tue radiografie o scansioni. Il nostro team esaminerà e creerà un piano di trattamento personalizzato.',

  'how.step2.number': '02',
  'how.step2.title': 'Scegli la supervisione',
  'how.step2.desc': 'Seleziona la tua opzione di supervisione preferita: medico terzo indipendente, il tuo dentista (riceve il 10%), o il nostro esperto interno.',

  'how.step3.number': '03',
  'how.step3.title': 'Ricevi il trattamento con trasparenza',
  'how.step3.desc': 'Ricevi il tuo trattamento nella nostra clinica accreditata JCI. Il tuo supervisore esamina tutte le radiografie, scansioni e progressi in tempo reale.',

  'how.step4.number': '04',
  'how.step4.title': 'Cure di follow-up',
  'how.step4.desc': 'Continua le cure con il tuo dentista che ha piena conoscenza del tuo trattamento. Forniamo tutti i documenti e supporto continuo.',

  // Supervision
  'supervision.badge': 'Sei protetto ad ogni passo',
  'supervision.title': 'Preoccupato di andare all\'estero per cure dentali?',
  'supervision.subtitle': 'Quella preoccupazione è completamente valida — ed è esattamente per questo che abbiamo costruito questo. Ogni paziente ha un supervisore dedicato che monitora il trattamento dal primo all\'ultimo giorno.',
  'supervision.swipeHint': 'Scorri per esplorare le opzioni',
  'supervision.chooseOption': 'Scegli questa opzione durante la prenotazione',

  'supervision.option1.title': 'Medico terzo indipendente',
  'supervision.option1.badge': 'Più affidabile',
  'supervision.option1.desc': 'Qualcuno dalla tua parte che risponde solo a te — non alla clinica. Esaminano ogni scansione, approvano ogni passo e si assicurano che nulla venga tralasciato.',
  'supervision.option1.feature1': 'Esamina le tue radiografie prima che inizi qualsiasi cosa',
  'supervision.option1.feature2': 'Approva il tuo piano di trattamento in modo indipendente',
  'supervision.option1.feature3': 'Controlla ad ogni fase delle tue cure',
  'supervision.option1.feature4': 'Conferma che il risultato finale soddisfi lo standard',
  'supervision.option1.feature5': 'Zero conflitto di interessi — lavorano per te',
  'supervision.option1.pricing': 'Cosa ottieni: Supervisione indipendente completa',

  'supervision.option2.title': 'Il tuo dentista di fiducia',
  'supervision.option2.badge': 'Più confortevole',
  'supervision.option2.desc': 'Il dentista di cui ti fidi già rimane parte del tuo percorso. Conosce la tua storia, ti conosce — e rimane informato ad ogni passo.',
  'supervision.option2.feature1': 'Il tuo dentista riceve tutti i documenti e le scansioni',
  'supervision.option2.feature2': 'Aggiornato ad ogni fase del trattamento',
  'supervision.option2.feature3': 'Gestisce il tuo follow-up a casa',
  'supervision.option2.feature4': 'Guadagna il 10% del costo del trattamento per il suo tempo',
  'supervision.option2.feature5': 'Continuità perfetta — nessun ricominciare da capo',
  'supervision.option2.pricing': 'Cosa ottieni: Cure familiari, senza lacune',

  'supervision.option3.title': 'Il nostro esperto interno',
  'supervision.option3.badge': 'Incluso',
  'supervision.option3.desc': 'Uno specialista senior con oltre 15 anni di esperienza supervisiona il tuo trattamento in loco. Non sei mai solo un paziente — sei una priorità.',
  'supervision.option3.feature1': 'Oltre 15 anni di esperienza specialistica',
  'supervision.option3.feature2': 'Presente in clinica durante tutte le tue cure',
  'supervision.option3.feature3': 'Risponde immediatamente se qualcosa non va',
  'supervision.option3.feature4': 'Mantiene ogni passo al massimo standard',
  'supervision.option3.feature5': 'Già incluso — nessun costo aggiuntivo per te',
  'supervision.option3.pricing': 'Cosa ottieni: Occhi esperti, sempre presenti',

  'supervision.why.title': 'Non dovresti dover semplicemente sperare per il meglio',
  'supervision.why.desc': 'Andare all\'estero per cure dentali richiede coraggio. Ti stai fidando di persone che non hai mai incontrato, in un paese che potresti non conoscere, con qualcosa di personale come il tuo sorriso. Abbiamo costruito il nostro sistema di supervisione perché crediamo che tu meriti più di una promessa — meriti una persona reale che vigili su ogni decisione presa riguardo alle tue cure.',

  // CTA
  'cta.title.line1': 'Il tuo sorriso ha aspettato',
  'cta.title.line2': 'Già abbastanza a lungo',
  'cta.subtitle1': 'Sappiamo che non è facile fare questo passo. L\'incertezza, le domande, i "e se" — li sentiamo ogni giorno. È esattamente per questo che siamo qui.',
  'cta.subtitle2': 'La tua prima conversazione è gratuita, senza pressioni e completamente alle tue condizioni. Parla con noi — pensiamo al resto.',
  'cta.button.primary': 'Sono pronto a parlare',
  'cta.button.secondary': 'Chatta su WhatsApp',
  'cta.badge1': 'Medici veri. Cure vere.',
  'cta.badge2': 'Nessuna pressione. Nessuna fretta.',
  'cta.badge3': 'Supportato ad ogni passo.',
  'cta.badge4': 'Risultati veri. Persone vere.',

  // Footer
  'footer.brand.desc': 'Crediamo che tutti meritino di sentirsi sicuri del proprio sorriso. Siamo qui per renderlo possibile — in modo sicuro, onesto e con un medico vero al tuo fianco.',
  'footer.cta': 'Prenota una consulenza',
  'footer.treatments': 'Trattamenti',
  'footer.company': 'Azienda',
  'footer.resources': 'Risorse',
  'footer.phone': 'Telefono',
  'footer.email': 'Email',
  'footer.location': 'Posizione',
  'footer.locationValue': 'Istanbul, Turchia',
  'footer.copyright': '© {{year}} Plexus Alliance. Tutti i diritti riservati.',
  'footer.poweredBy': 'Sviluppato da Readdy',

  // About page
  'about.hero.badge': 'La nostra storia',
  'about.hero.title': 'Abbiamo costruito la rete di sicurezza che mancava al turismo dentale',
  'about.hero.subtitle': 'Plexus Alliance è stata fondata su una semplice convinzione: i pazienti meritano una voce indipendente nel proprio trattamento — specialmente quando sono lontani da casa.',
  'about.mission.badge': 'La nostra missione',
  'about.mission.title': 'Cure dentali trasparenti e supervisionate per ogni paziente, ovunque.',
  'about.mission.desc': 'Colleghiamo i pazienti alle migliori cliniche dentali di Istanbul fornendo al contempo lo strato di supervisione indipendente che la maggior parte delle aziende di turismo dentale semplicemente non offre.',
  'about.values.badge': 'In cosa crediamo',
  'about.values.title': 'I nostri valori fondamentali',
  'about.value1.title': 'Indipendenza',
  'about.value1.desc': 'I nostri supervisori rispondono solo a te — mai alla clinica.',
  'about.value2.title': 'Trasparenza',
  'about.value2.desc': 'Ogni documento, ogni scansione, ogni decisione — completamente visibile per te.',
  'about.value3.title': 'Continuità',
  'about.value3.desc': 'Le tue cure non si fermano quando sali sull\'aereo di ritorno.',
  'about.value4.title': 'Accessibilità',
  'about.value4.desc': 'Le cure dentali di livello mondiale non dovrebbero essere un privilegio. Le rendiamo accessibili.',

  // Treatments page
  'treatments.hero.badge': 'Tutti i trattamenti',
  'treatments.hero.title': 'Trova il tuo trattamento',
  'treatments.hero.subtitle': 'Dai singoli impianti ai restyling completi del sorriso — ogni trattamento è supervisionato, trasparente e a un prezzo equo.',
  'treatments.filter.all': 'Tutti i trattamenti',
  'treatments.filter.implants': 'Impianti',
  'treatments.filter.cosmetic': 'Cosmetico',
  'treatments.filter.orthodontics': 'Ortodonzia',
  'treatments.filter.restorative': 'Restaurativo',
  'treatments.cta.title': 'Non sei sicuro di quale trattamento hai bisogno?',
  'treatments.cta.desc': 'Dicci cosa ti disturba — esamineremo il tuo caso gratuitamente e raccomanderemo il percorso giusto.',
  'treatments.cta.button': 'Ottieni una valutazione gratuita',

  // Book Treatment page
  'book.hero.badge': 'Inizia il tuo percorso',
  'book.hero.title': 'Prenota il tuo trattamento',
  'book.hero.subtitle': 'Compila i dettagli qui sotto e ti risponderemo entro poche ore con un piano personalizzato.',
  'book.form.name': 'Nome completo',
  'book.form.email': 'Indirizzo email',
  'book.form.phone': 'Telefono / WhatsApp',
  'book.form.treatment': 'Trattamento di interesse',
  'book.form.supervision': 'Preferenza di supervisione',
  'book.form.message': 'Dicci di più (opzionale)',
  'book.form.submit': 'Invia la mia richiesta',
  'book.form.submitting': 'Invio in corso...',
  'book.form.success': 'Richiesta inviata! Ti contatteremo entro poche ore.',

  // Partner Registration page
  'partner.hero.badge': 'Diventa partner',
  'partner.hero.title': 'Unisciti alla rete Plexus Alliance',
  'partner.hero.subtitle': 'Sei un dentista, una clinica o un professionista sanitario? Diventa partner e guadagna aiutando i tuoi pazienti ad accedere a cure di livello mondiale.',
  'partner.form.submit': 'Invia candidatura',

  // How It Works page
  'hiw.hero.badge': 'Il processo',
  'hiw.hero.title': 'Come funziona',
  'hiw.hero.subtitle': 'Dal tuo primo messaggio all\'ultimo controllo — ecco esattamente cosa succede, passo dopo passo.',
  'hiw.faq.title': 'Hai ancora domande?',
  'hiw.cta.title': 'Pronto a fare il primo passo?',
  'hiw.cta.subtitle': 'Inizia con un singolo messaggio. Dicci di cosa hai bisogno — ci occupiamo noi del resto.',
  'hiw.cta.button': 'Inizia il mio percorso',

  // Supervision page
  'sup.hero.badge': 'La tua protezione',
  'sup.hero.title': 'Supervisione medica',
  'sup.hero.subtitle': 'L\'unica cosa che la maggior parte delle aziende di turismo dentale non offre — e l\'unica cosa che fa tutta la differenza.',
  'sup.why.title': 'La maggior parte delle cliniche lavora per se stessa. Noi lavoriamo per te.',
  'sup.options.title': 'Tre modi per rimanere protetto',
  'sup.pillars.title': 'Cosa riceve ogni paziente supervisionato',
  'sup.compare.title': 'Con supervisione vs. senza',
  'sup.faq.title': 'Domande sulla supervisione',
  'sup.cta.title': 'La tua salute merita una voce indipendente.',
  'sup.cta.button': 'Prenota con supervisione',

  // Common UI
  'common.learnMore': 'Scopri di più',
  'common.bookNow': 'Prenota ora',
  'common.startJourney': 'Inizia il mio percorso',
  'common.getStarted': 'Inizia',
  'common.contactUs': 'Contattaci',
  'common.readMore': 'Leggi di più',
  'common.viewAll': 'Vedi tutto',
  'common.close': 'Chiudi',
  'common.back': 'Indietro',
  'common.next': 'Avanti',
  'common.loading': 'Caricamento...',
  'common.error': 'Qualcosa è andato storto. Riprova.',
  'common.required': 'Questo campo è obbligatorio',
  'common.optional': 'Opzionale',
  'common.saving': 'Risparmio di',
  'common.perTooth': 'per dente',
  'common.included': 'Incluso',
  'common.mostTrusted': 'Più affidabile',
  'common.mostComfortable': 'Più confortevole',
  'common.yearsExperience': 'anni di esperienza',
  'common.patients': 'pazienti',
  'common.countries': 'paesi',
  'common.savings': 'risparmi',
};

export default common;
